import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import { Lightbox } from './lightbox';
import { couponLightboxStyles } from './css/styles';
import couponIcon from './css/coupon-icon.svg';

export const CouponLightbox = injectSheet(couponLightboxStyles)(({
  children,
  classes,
  buttonOkText,
  isOpen,
  onCancel,
  onSubmit,
  title,
  showClose,
}) => (
  <Lightbox
    buttonOkText={buttonOkText}
    icon={(
      <img
        className={classes.couponIcon}
        src={couponIcon}
        alt=""
      />
    )}
    isOpen={isOpen}
    onCancel={onCancel}
    onSubmit={onSubmit}
    title={title}
    showClose={showClose}
  >
    {children}
  </Lightbox>
));

CouponLightbox.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  buttonOkText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showClose: PropTypes.bool,
};

CouponLightbox.defaultProps = {
  isOpen: true,
  showClose: true,
};
CouponLightbox.displayName = 'CouponLightbox';
